import React, { useState, useEffect } from 'react';
import styles from './viewOtherReviews.module.scss';
import ReactGA from 'react-ga';
import { Helmet } from "react-helmet";
import CustomNavbar from '../../customNavbar';
import { Accordion, Card, Col, Row, Button, Container, Form, Alert } from 'react-bootstrap';
import { Formik } from 'formik';
import * as yup from 'yup';
import { CustomButton } from '../../../shared/customButton';
import { getExternalAssessmentsByGroup, submitExternalAssessmentReview, getPresignedUrlToViewExternalAssessmentSubmission } from '../../../../services/util/externalAssessments';
import CSSLoader from '../../../shared/cssLoader';
import { CustomSearch } from '../../../shared/customSearch';
import { useParams, useHistory } from 'react-router-dom';
import Select from 'react-select';
import makeAnimated from 'react-select/animated';
import { CustomCheckBox } from '../../../shared/customCheckBox';
import ViewAssessmentModal from './viewAssessment';
import StarRating from '../../../shared/rate'
import { CustomDropdown } from '../../../shared/customDropdown';
import { CustomStatusLabel } from '../../../shared/customStatusLabel';
import { CustomIconButton } from '../../../shared/customIconButton';
import { CustomPreIcon } from '../../../shared/customPreIcon';
import AddCandiateNoteModal from '../../common/addCandidateSpecialNoteModal';
import Avatar from 'react-avatar';
let moment = require('moment-timezone');


function ViewOtherReviews(props) {
    let [accordionIcon, setAccordionIcon] = useState(true);
    let [sideBarOpen, setSideBar] = useState(false);
    let [marks, setMarks] = useState(-1);
    let [marksError, setMarksError] = useState(null);
    let [dropdownError, setDropDownError] = useState();
    let [emptyMarksError, setEmptyMarksError] = useState(false);
    let [emptyOverallMarksError, setEmptyOverallMarksError] = useState(false);
    let [outOfRangeOverallMarksError, setOutOfRangeOverallMarksError] = useState(false);
    let [emptyCommentsError, setEmptyCommentsError] = useState(false);
    let [state, setState] = useState({
        comments: []
    });
    let [candidateList, setCandidateList] = useState([]);
    let [commonData, setCommonData] = useState({
        review_criteria: [],
    });
    let [selectedCandidateSession, setSelectedCandidateSession] = useState({})
    const [isSubmitLoading, setSubmitLoading] = useState(false)
    const [isLoading, setLoading] = useState(false);
    let [isURLLoading, setURLLoading] = useState(false);
    let [filteredValues, setFilteredValues] = useState([]);
    let [defaultStateType, setDefaultStateType] = useState({
        label: "All",
        value: 100
    })
    let [viewReviewValues, setviewReviewValues] = useState({
        submission_download_link: null,
        review_criteria: []
    });

    let [isAcknowledgeConfirmed, setAcknowledgeConfirmed] = useState(false);
    let [showViewAssessmentModal, setShowViewAssessmentModal] = useState(false);

    let [isDownloadSubmissionFileLoading, setIsDownloadSubmissionFileLoading] = useState(false);
    const [reviewCriteriaRating, setReviewCriteriaRating] = useState([]);
    let [calOverallMark, setCalOverallMark] = useState();
    let [getUsersIsLoading, getUsersSetLoading] = useState(false);
    let [specialNoteModalOpen, setSpecialNoteModalOpen] = useState(false);
    // let [assessmentModalData, setAssessmentModalData] = useState();



    const animatedComponents = makeAnimated();


    const history = useHistory();

    //getting query parameter value
    let search = window.location.search;
    let params = new URLSearchParams(search);

    let step_id = (params.get('step_id') ? params.get('step_id') : null);
    let seleted_state = (params.get('state') ? params.get('state') : 100);

    const breadcrumb = [
        {
            pathaddress: '/app/company/external-assessments',
            pathname: 'External Assessments',
            isActive: false,
            key: 1 + 'External Assessments'
        },
        {
            pathaddress: '',
            pathname: commonData.step_name,
            isActive: true,
            key: 1 + commonData.step_name
        }
    ];

    //dropdown assessment status types
    const StateTypes = [
        {
            label: "All",
            value: 100
        },
        {
            label: "Submitted for Marking",
            value: 5
        },
        {
            label: "Pending",
            value: 0
        },

    ];
    //dropdown values
    const dropValue = [
        {
            label: '--SELECT--',
            value: -1,
        },
        {
            label: '1',
            value: 1,
        },
        {
            label: '2',
            value: 2,
        },
        {
            label: '3',
            value: 3,
        },
        {
            label: '4',
            value: 4,
        },
        {
            label: '5',
            value: 5,
        },
        {
            label: '6',
            value: 6,
        },
        {
            label: '7',
            value: 7,
        },
        {
            label: '8',
            value: 8,
        },
        {
            label: '9',
            value: 9,
        },
        {
            label: '10',
            value: 10,
        },
    ]

    const schema = yup.object({
        comments: yup.string().trim().matches(/^[^<>=*$^]*$/, 'Remove restricted characters. such as: < > = $ * ^').required('Required'),
    });

    //add comment function
    function addComment(item) {
        setState(state => ({
            comments: [...state.comments, item]
        }));
    }

    //remove comment function
    function removeComment(item) {
        let array = [state.comments];
        if (item !== -1) {
            array[0].splice(item, 1);
            setState({
                comments: array[0]
            })
        }
    }

    //searching assessments
    function searchValues(searchValue) {
        let searchVal = searchValue.toLowerCase();
        if (searchValue == '') {
            setFilteredValues(candidateList)
        } else {
            const filtered = candidateList.filter(entry => Object.values(entry).some(val => typeof val === "string" && (val.toLowerCase()).includes(searchVal)));
            setFilteredValues(filtered);
        }

    }

    //set session ID and review candidate tab values
    function ViewReview(values) {
        setSelectedCandidateSession(values.external_assessment_session_id);
        setviewReviewValues(values)
    }

    const getURLForDownloadSubmission = async () => {
        setIsDownloadSubmissionFileLoading(true);
        let response = await getPresignedUrlToViewExternalAssessmentSubmission(selectedCandidateSession);
        if (response.success == true) {
            window.open(response.data.presigned_url);
            setIsDownloadSubmissionFileLoading(false);
        }
        else {
            setIsDownloadSubmissionFileLoading(false);
        }
    }


    const changeAccordionIcon = () => {
        setAccordionIcon(!accordionIcon)
    }

    const onSubmitForm = async (values, { resetForm }) => {
        setEmptyCommentsError(false)
        addComment(values.comments);
        resetForm({ comments: '' });
    }

    const submitCandidateReview = async () => {
        //using "marks" for older pipes and "overallmarks" for more recent tables
        //check whether comments and marks(calOverallMark or marks) null
        if (state.comments.length >= 0 && ((calOverallMark > -1 && calOverallMark < 101 && calOverallMark != "" && calOverallMark !== null) || marks !== -1)) {
            const reviewCriteriaData = [];
            for (let key in viewReviewValues.review_criteria) {
                for (let keys in reviewCriteriaRating) {
                    if (viewReviewValues.review_criteria[key].label === reviewCriteriaRating[keys].label) {
                        if (reviewCriteriaRating[keys].rate !== 0) {
                            const newOverallRating = {
                                _id: viewReviewValues.review_criteria[key]._id,
                                label: viewReviewValues.review_criteria[key].label,
                                rate: reviewCriteriaRating[keys].rate,
                            }
                            reviewCriteriaData.push(newOverallRating)
                        }
                    }
                }
            }

            setSubmitLoading(true);
            let score = calOverallMark !== null ? calOverallMark : (marks * 10).toFixed(1);
            let respond = await submitExternalAssessmentReview(selectedCandidateSession, score, state.comments, reviewCriteriaData ? reviewCriteriaData : null);
            if (respond.success === true) {
                setSelectedCandidateSession({});
                setMarks(null);
                setState({ comments: [] });
                setSubmitLoading(false);
                setSideBar(false);
                props.GetTaskValues();
                loadInitialData();
            } else {
                setSubmitLoading(false);
            }

        } else {
            if (marks === -1) {
                setEmptyMarksError(true)
            }
            if (calOverallMark < 0 || calOverallMark > 100 || calOverallMark === null || calOverallMark == "") {
                setOutOfRangeOverallMarksError(true)
            }
        }
    }

    //set assessment status and load assessments
    const changeAssessmentStatusType = async (type) => {
        setLoading(true);
        let search = window.location.search;
        let params = new URLSearchParams(search);
        let step_id = params.get('step_id');
        setDefaultStateType(type);
        let respond = await getExternalAssessmentsByGroup(step_id, type.value);
        if (respond.success == true) {
            setCommonData(respond.data.common_details);
            setCandidateList(respond.data.candidate_object_list);
            setFilteredValues(respond.data.candidate_object_list);
            setLoading(false);
        }

    }
    async function loadInitialData() {
        setLoading(true);
        //getting query parameter value
        let search = window.location.search;
        let params = new URLSearchParams(search);
        let step_id = params.get('step_id');
        let selectedState = parseInt(seleted_state)

        if (step_id) {

            let respond = await getExternalAssessmentsByGroup(step_id, selectedState);
            if (respond.success === true) {
                if (respond.data && respond.data.common_details && respond.data.candidate_object_list) {
                    setCommonData(respond.data.common_details);
                    setCandidateList(respond.data.candidate_object_list);
                    setFilteredValues(respond.data.candidate_object_list);
                    //setting statelabel for selected state
                    if (selectedState != 100) {
                        for (let index = 0; index < StateTypes.length; index++) {
                            if (StateTypes[index].value == selectedState) {
                                setDefaultStateType(StateTypes[index]);

                            }
                        }
                    }

                    setLoading(false);
                } else {
                    if (selectedState === 0 || selectedState === 5) {
                        history.push({
                            pathname: `/app/company/external-assessments/group`,
                            search: `?step_id=${step_id}&state=${100}`,

                        });
                    } else {
                        props.history.push('/app/company/external-assessments');
                    }

                }

            } else {
                props.history.push('/app/company/external-assessments');
                setLoading(false);
            }
        }
    }

    const changeAcknowledgeState = () => {
        setAcknowledgeConfirmed(!isAcknowledgeConfirmed);
    }

    const showAssessment = () => {
        setShowViewAssessmentModal(true);
    }
    const setModalClose = () => {
        setShowViewAssessmentModal(false);
    }

    //open and close note modal
    const openSpecialNoteModal = () => {
        setSpecialNoteModalOpen(true);
    }

    const changeSelectedStateURL = async (state) => {
        history.push({
            pathname: `/app/company/external-assessments/group`,
            search: `?step_id=${step_id}&state=${state}`,

        });
    }
    function viewCandidate(val) {
        let path = `/app/company/candidate`;
        let search = 'cid=' + val;

        const url = `${path}?${search}`;
        window.open(url);
    }
    const handleRatingChange = (id, rating, label) => {
        let data = {
            rate: rating,
            label: label,
        }
        setReviewCriteriaObj(data);
    };
    const setReviewCriteriaObj = (data) => {
        const reviewCriteriaList = [...reviewCriteriaRating];
        if (reviewCriteriaRating.length === 0) {
            setReviewCriteriaRating(current => ([...current, data]));
        }
        else {
            let reviewRating = reviewCriteriaList.find(reviewCriteriaRating => reviewCriteriaRating.label === data.label);
            if (reviewRating) {
                reviewRating.rate = data.rate === null ? 0 : data.rate;
                setReviewCriteriaRating(reviewCriteriaList);
            }
            else {
                setReviewCriteriaRating(current => ([...current, data]));
            }
        }
    }

    const itemsPerPage = 9; // Number of items to display per page
    const [currentPage, setCurrentPage] = useState(1); // Current page number

    const handlePreviousClick = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
    };

    const handleNextClick = () => {
        const totalPages = Math.ceil(filteredValues.length / itemsPerPage);
        if (currentPage < totalPages) {
            setCurrentPage(currentPage + 1);
        }
    };
    const totalPages = Math.ceil(filteredValues.length / itemsPerPage);

    useEffect(() => {
        calculateMarks();
    }, [reviewCriteriaRating])

    const calculateMarks = () => {
        var results = 0;
        var addition = 0;
        var divider = 0;
        for (let key in reviewCriteriaRating) {
            if (reviewCriteriaRating[key].rate !== 0) {
                addition += reviewCriteriaRating[key].rate;
                divider += 1;
            }
        }
        if (addition !== 0) {
            results = (addition / (divider * 5)) * 100;
        }
        setCalOverallMark(results === 0 ? null : results.toFixed(1))
    };

    function viewCandidate(val) {
        let path = `/app/company/candidate`;
        let search = 'cid=' + val;

        const url = `${path}?${search}`;
        window.open(url);
    }

    useEffect(() => {
        loadInitialData();
    }, [])

    useEffect(() => {
        let pageHit = '/app/company/external-assessments';
        props.toggleInterviewView(false);
        ReactGA.initialize(`${process.env.REACT_APP_GOOGLE_ANALYTICS_ID}`);
        ReactGA.pageview(pageHit);
    }, [])


    return (
        <div>
            <Helmet>
                <title>External Assessment Reviews | HireTrace</title>
            </Helmet>


            {isLoading ?
                <div className={styles.loadingDiv}>
                    <Col sm={{ span: 4, offset: 4 }}>
                        <CSSLoader />
                    </Col>
                </div>
                :
                <div>
                    <div className={sideBarOpen === true ? `${styles.sidenav} ${styles.sidenavOpen}` : styles.sidenav}>
                        <div className={styles.sideNavBody}>
                            <div className={styles.modalCancelBtnDiv}>
                                <Button className={styles.modalCancelBtn} onClick={() => { setSideBar(false); setSelectedCandidateSession({}); setMarks(null); setState({ comments: [] }); }}>
                                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M13.5 4.5L4.5 13.5" stroke="#24859A" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                        <path d="M4.5 4.5L13.5 13.5" stroke="#24859A" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                </Button>
                            </div>
                            <Container className="mt-4">
                                <Col>
                                    <p className={styles.sideBarTopic}>
                                        Assignment Details
                                    </p>
                                    <Card className={styles.cardOuterBox}>
                                        <Card.Body >
                                            <div className={styles.cardTitleBox}>
                                                <Row>
                                                    <Col sm={1}>
                                                        <Avatar name={viewReviewValues.candidate_name} size="32" round={true} />
                                                    </Col>
                                                    <Col sm={7} className={styles.detailsValueMainDiv}>
                                                        <Row className={styles.tableJobDetailsRow}>
                                                            <p className={styles.tableJobDetails}>{viewReviewValues.candidate_name}</p><i class="fas fa-external-link-alt ml-1S" id={styles.openInNewtabIcon} onClick={() => viewCandidate(viewReviewValues?.candidate_id)}></i> 
                                                        </Row>
                                                        <Row className={styles.tableJobDetailsRow}>
                                                            <p className={styles.tableSecondJobDetails}>{viewReviewValues?.candidate_email}</p>
                                                        </Row>
                                                    </Col>
                                                    <Col sm={4} className='d-flex align-items-center justify-content-center'>
                                                        <CustomStatusLabel type={viewReviewValues.state === 5 ? 'successStatus' : viewReviewValues.state === 0 ? 'warningStatus' : 'dangerStatus'} label={viewReviewValues.state === 5 ? 'Submitted for marking' : viewReviewValues.state === 0 ? 'Pending' : viewReviewValues.state === -40 ? 'Expired' : null}></CustomStatusLabel>
                                                    </Col>
                                                </Row>
                                            </div>
                                            <hr className={styles.horizontalDivider} />
                                            <div>
                                                <Row>
                                                    <Col sm={4}>
                                                        <Row >
                                                            <Col sm={12} className={styles.asseSideIconDiv}>
                                                                <p className={styles.asseSideJobDetails}>Assessment</p>
                                                                <CustomIconButton
                                                                    toolTipId="viewAssessement"
                                                                    type="successBtn"
                                                                    showToolTip={true}
                                                                    toolTip={'View assessment'}
                                                                    icon={
                                                                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="15" viewBox="0 0 14 15" fill="none">
                                                                            <path d="M12.2941 4.25V4.12C12.2941 3.0279 12.2941 2.48185 12.0633 2.06472C11.8603 1.6978 11.5363 1.39949 11.1379 1.21254C10.6849 1 10.0919 1 8.90588 1H4.38824C3.20224 1 2.60925 1 2.15626 1.21254C1.75779 1.39949 1.43384 1.6978 1.23081 2.06472C1 2.48185 1 3.0279 1 4.12V10.88C1 11.9721 1 12.5182 1.23081 12.9353C1.43384 13.3022 1.75779 13.6005 2.15626 13.7875C2.60925 14 3.20224 14 4.38824 14H7M7 6.85H3.82353M6.29412 9.45H3.82353M9.47059 4.25H3.82353M10.8824 11.4V7.825C10.8824 7.28652 11.3564 6.85 11.9412 6.85C12.5259 6.85 13 7.28652 13 7.825V11.4C13 12.477 12.0519 13.35 10.8824 13.35C9.71281 13.35 8.76471 12.477 8.76471 11.4V8.8" stroke="#12B76A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                                        </svg>
                                                                    }
                                                                    handleClick={() => showAssessment()}
                                                                />
                                                            </Col>
                                                        </Row>
                                                    </Col>
                                                    <Col sm={4}>
                                                        <Row>
                                                            <Col className={styles.asseSideIconDiv}>
                                                                <p className={styles.asseSideJobDetails}>Passing Threshold: {viewReviewValues.pass_score}%</p>
                                                            </Col>
                                                        </Row>
                                                    </Col>
                                                    <Col sm={4}>
                                                        <Row>
                                                            <Col sm={12} className={styles.asseSideIconSecondDiv}>
                                                                <p className={styles.asseSideJobDetails}>Submitted File</p>
                                                                {(viewReviewValues.submission_download_link ? (
                                                                    <CustomIconButton
                                                                        toolTipId="downloadAssessement"
                                                                        type="successBtn"
                                                                        toolTip={'Download assessment'}
                                                                        icon={!isDownloadSubmissionFileLoading && (
                                                                            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                                                                                <path d="M4.6665 7L6.99984 9.33333M6.99984 9.33333L9.33317 7M6.99984 9.33333V4.66666M12.8332 7C12.8332 10.2217 10.2215 12.8333 6.99984 12.8333C3.77818 12.8333 1.1665 10.2217 1.1665 7C1.1665 3.77834 3.77818 1.16666 6.99984 1.16666C10.2215 1.16666 12.8332 3.77834 12.8332 7Z" stroke="#12B76A" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                                            </svg>
                                                                        )}
                                                                        handleClick={getURLForDownloadSubmission}
                                                                    />
                                                                )
                                                                    :
                                                                    (
                                                                        <CustomIconButton
                                                                            toolTipId="waitDownloadAssessement"
                                                                            type="successBtn"
                                                                            toolTip={'Waiting for assessment'}
                                                                            showToolTip={true}
                                                                            icon={
                                                                                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                                                                                    <path d="M4.6665 7L6.99984 9.33333M6.99984 9.33333L9.33317 7M6.99984 9.33333V4.66666M12.8332 7C12.8332 10.2217 10.2215 12.8333 6.99984 12.8333C3.77818 12.8333 1.1665 10.2217 1.1665 7C1.1665 3.77834 3.77818 1.16666 6.99984 1.16666C10.2215 1.16666 12.8332 3.77834 12.8332 7Z" stroke="#12B76A" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                                                </svg>
                                                                            }
                                                                            disabled={isDownloadSubmissionFileLoading}
                                                                        />

                                                                    ))}
                                                            </Col>

                                                        </Row>
                                                    </Col>
                                                </Row>
                                            </div>

                                            <hr className={styles.horizontalDivider} />

                                            <div>
                                                <Col sm={12} className='ml-2'>
                                                    
                                                    <Row className={styles.tableJobDetailsRow}>
                                                        <p className={styles.tableJobDetails}>Review Criteria</p>
                                                    </Row>
                                                    <Row className={styles.tableJobDetailsRow}>
                                                        <p className={styles.tableSecondJobDetails}>{commonData.evaluation_criteria}</p>
                                                    </Row>
                                                </Col>
                                            </div>
                                        </Card.Body>
                                    </Card>

                                    <div>
                                        <div>
                                            <div>
                                                <div className={styles.addNoteDiv}>
                                                    <p className={styles.noteValue} onClick={() => openSpecialNoteModal()}>Add special note</p>
                                                </div>
                                                {viewReviewValues.review_criteria.length ?
                                                    <div className='mt-n4'>
                                                        <p className={styles.reviewFeedbackLabel}>Evaluation Criteria</p>
                                                        {viewReviewValues.review_criteria.map((item, i) => (
                                                            <div className={styles.reviewFeedbackBox} key={i}>

                                                                <div className={styles.reviewFeedbackBoxBody}>
                                                                    <span className={styles.reviewFeedbackInnerBox}>
                                                                        <span className={styles.reviewFeedbackValue}>{item.label}</span>
                                                                        <span><StarRating className="mr-4" disabled={false} id={i} onRatingChange={(reviewCriteriaRating) => {handleRatingChange(i, reviewCriteriaRating, item.label); setOutOfRangeOverallMarksError(false)}} /></span>
                                                                    </span>
                                                                </div>
                                                                <hr className={styles.subTopicDivider} />
                                                            </div>
                                                        ))
                                                        }
                                                        <p className={styles.reviewFeedbackOverallScore}><span className={styles.reviewFeedbackOverallScoreLabel}>Overall Marks : </span><span className={styles.reviewFeedbackOverallScoreLabelValue}>{(calOverallMark && calOverallMark > 0) ? calOverallMark : 0}%</span></p>

                                                        {(outOfRangeOverallMarksError === true) &&
                                                            <p className={styles.reviewErrorMsg}> You have to give at least one star rating.</p>
                                                        }
                                                    </div>
                                                    :
                                                    <div>
                                                        <Formik
                                                            initialValues={{ marks: marks }}>

                                                            {({
                                                                values,
                                                                errors,
                                                                setFieldValue,
                                                                handleSubmit,
                                                                submitCount
                                                            }) => (
                                                                <div>
                                                                    <Form noValidate onSubmit={handleSubmit}>
                                                                        <CustomDropdown
                                                                            label="Overall Marks"
                                                                            classLabel="defaultLabel"
                                                                            labelDesc="Score candidate 1 to 10. 1 is lowest, 10 is highest."
                                                                            controlId="marks"
                                                                            name="marks"
                                                                            value={values.marks}
                                                                            handleOnChange={(e) => { setFieldValue('marks', e.target.value); setMarks(parseInt(e.target.value)) }}
                                                                            dropdownValues={dropValue}
                                                                            errorMessage={dropdownError}
                                                                            onFocus={() => setEmptyMarksError(false)}
                                                                            isInvalid={emptyMarksError}
                                                                        />
                                                                    </Form>
                                                                    {(emptyMarksError === true && marks === -1) &&
                                                                        <p className={styles.reviewErrorMsg}> Select Valid Mark.</p>
                                                                    }
                                                                </div>
                                                            )}
                                                        </Formik>
                                                    </div>
                                                }

                                            </div>
                                        </div>

                                        <div>
                                            <Formik
                                                validationSchema={schema}
                                                onSubmit={(values, resetForm) => onSubmitForm(values, resetForm)}
                                                initialValues={{}}>

                                                {({
                                                    values,
                                                    errors,
                                                    setFieldValue,
                                                    handleChange,
                                                    handleSubmit,
                                                    submitCount,
                                                    resetForm
                                                }) => (
                                                    <div>
                                                        <Form noValidate onSubmit={handleSubmit}>
                                                            <Form.Group controlId="comments">
                                                                <Form.Label className={styles.textareaLabel}>Comments</Form.Label>
                                                                <Form.Control as="textarea" name="comments" value={values.comments || ''} onChange={(e) => { setFieldValue('comments', e.target.value); }} rows={3} className={styles.textareaBox} isInvalid={errors.comments || emptyCommentsError} onFocus={() => setEmptyCommentsError(false)} />
                                                                <p className={styles.errorMsg}>{errors.comments}</p>
                                                            </Form.Group>
                                                            {(emptyCommentsError === true && !errors.comments) &&
                                                                <p className={styles.errorMsg}> You must add at least one comment.</p>
                                                            }
                                                            <div>
                                                                <CustomButton
                                                                    id="add_comment"
                                                                    buttonType="submit"
                                                                    label="Add Comment"
                                                                    type="secondaryBtn"
                                                                    frontIcon={<svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
                                                                        <path d="M9.99984 4.22156V15.8882M4.1665 10.0549H15.8332" stroke="#2790A6" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
                                                                    </svg>}
                                                                    handleClick={handleChange}
                                                                />
                                                            </div>
                                                            {submitCount > 0 && setMarksError(errors.marks)}
                                                            {(state.comments).length > 0 &&
                                                                <p className={styles.commentsLabel}>Comments About Candidate</p>
                                                            }
                                                            <div className='mb-1 pb-1'>
                                                                {
                                                                    state.comments.map((item, i) => (
                                                                        <Row className='m-0 p-1'>
                                                                            <Col sm={11} className='m-0 p-0'>
                                                                                <Card className={styles.commentBox} key={i}>
                                                                                    <Card.Body className={styles.commentBoxBody}>
                                                                                        <span className={styles.commentsInnerBox}>
                                                                                            <span className={styles.commentValue}>{item}</span>
                                                                                        </span>
                                                                                    </Card.Body>
                                                                                </Card>
                                                                            </Col>
                                                                            <Col sm={1}>
                                                                                <span className={styles.cancelIconDiv} onClick={() => removeComment(i)} key={(props.keyValue) + 1}>
                                                                                    <svg className={styles.cancelIcon} width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                                        <g id="trash-01">
                                                                                            <path id="Icon" d="M13.3333 5.49999V4.83332C13.3333 3.8999 13.3333 3.43319 13.1517 3.07667C12.9919 2.76307 12.7369 2.5081 12.4233 2.34831C12.0668 2.16666 11.6001 2.16666 10.6667 2.16666H9.33333C8.39991 2.16666 7.9332 2.16666 7.57668 2.34831C7.26308 2.5081 7.00811 2.76307 6.84832 3.07667C6.66667 3.43319 6.66667 3.8999 6.66667 4.83332V5.49999M8.33333 10.0833V14.25M11.6667 10.0833V14.25M2.5 5.49999H17.5M15.8333 5.49999V14.8333C15.8333 16.2335 15.8333 16.9335 15.5608 17.4683C15.3212 17.9387 14.9387 18.3212 14.4683 18.5608C13.9335 18.8333 13.2335 18.8333 11.8333 18.8333H8.16667C6.76654 18.8333 6.06647 18.8333 5.53169 18.5608C5.06129 18.3212 4.67883 17.9387 4.43915 17.4683C4.16667 16.9335 4.16667 16.2335 4.16667 14.8333V5.49999" stroke="#B42318" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
                                                                                        </g>
                                                                                    </svg>
                                                                                </span>
                                                                            </Col>
                                                                        </Row>
                                                                    ))
                                                                }
                                                            </div>
                                                            {(viewReviewValues.state === 0) &&
                                                                <div className="mt-4">
                                                                    <CustomCheckBox
                                                                        id="acceptConditions"
                                                                        controlId="acceptConditions"
                                                                        name="condition"
                                                                        label="I hereby acknowledge that candidate hasn't submitted the assessment but I have added marks and comments "
                                                                        handleOnChange={() => changeAcknowledgeState()}
                                                                        type="defaultCheckBoxLight"
                                                                        // errorMessage={errors.acceptConditions}
                                                                        ischecked={isAcknowledgeConfirmed}
                                                                    />
                                                                </div>}
                                                            <div className="mt-3">
                                                                <CustomButton
                                                                    buttonType="submit"
                                                                    type="primaryBtn"
                                                                    label="Submit"
                                                                    handleClick={submitCandidateReview}
                                                                    backicon={
                                                                        isSubmitLoading &&
                                                                        <i className="fas fa-circle-notch fa-spin"></i>
                                                                    }
                                                                    disabled={isSubmitLoading ? true : !isAcknowledgeConfirmed && viewReviewValues.state === 0 ? true : false}
                                                                />
                                                            </div>
                                                        </Form>
                                                    </div>
                                                )}
                                            </Formik>
                                        </div>
                                    </div>
                                </Col>
                            </Container>


                        </div>
                    </div>

                    <div className={styles.backgroundFixedComponents}>
                        <CustomNavbar history={props.mainHistory} breadcrumbArray={breadcrumb} />
                        {
                            showViewAssessmentModal === true &&
                            <ViewAssessmentModal showDetailsModal={showViewAssessmentModal} assessmentData={viewReviewValues} modalClose={setModalClose} />
                        }
                        {/* add note modal open */}
                        {specialNoteModalOpen &&
                            <AddCandiateNoteModal showModal={specialNoteModalOpen} handleClose={() => setSpecialNoteModalOpen(false)} candidateID={viewReviewValues.candidate_id} />
                        }
                        {/* add note modal close */}
                    </div>
                    <div className={styles.BodyContainer}>
                        <Col>
                            <Col>
                                <div>
                                    <Row>
                                        <Col sm={4} className="mb-2">
                                            <Select
                                                options={StateTypes}
                                                class="react-select__control"
                                                components={animatedComponents}
                                                value={defaultStateType}
                                                onChange={(e) => {
                                                    changeAssessmentStatusType(e);
                                                    changeSelectedStateURL(e.value)
                                                }}
                                                styles={
                                                    {
                                                        ...styles,
                                                        control: (base, state) => ({
                                                            ...base,
                                                            '&:hover': { borderColor: '#24859a' }, // border style on hover
                                                            border: '1px solid #D0D5DD', // default border color
                                                            borderRadius: '6px',
                                                            boxShadow: 'none', // no box-shadow
                                                            height: '44px',
                                                            fontFamily: 'var(--app-primary-font-style)',
                                                            fontWeight: 'var(--app-regular-font-weight)',
                                                            fontSize: 'var(--app-primary-font-size)',

                                                        }),
                                                        option: (styles, { isDisabled, isFocused, isSelected }) => {
                                                            return {
                                                                ...styles,
                                                                background: isDisabled
                                                                    ? null
                                                                    : isSelected
                                                                        ? 'rgba(45, 166, 192, 0.1)'
                                                                        : isFocused
                                                                            ? 'rgba(45, 166, 192, 0.1)'
                                                                            : null,
                                                                color: isDisabled
                                                                    ? '#ccc'
                                                                    : isSelected
                                                                        ? '#24859A'
                                                                        : '#24859A',
                                                                cursor: isDisabled ? 'not-allowed' : 'default',

                                                                ':active': {
                                                                    ...styles[':active'],
                                                                    background:
                                                                        !isDisabled && (isSelected ? 'rgba(45, 166, 192, 0.1)' : 'rgba(45, 166, 192, 0.1)'),
                                                                },
                                                            };
                                                        },
                                                    }
                                                }
                                            />
                                        </Col>
                                        <Col sm={8} className="mb-2">
                                            <CustomSearch
                                                placeholder="Search"
                                                handleOnChange={(e) => searchValues(e.target.value)}
                                            />
                                        </Col>

                                    </Row>
                                </div>
                            </Col>

                            <div className={styles.tableContainer}>
                                <div className={styles.tableFirstRowMainHeaderDiv}>
                                    <Col sm={4} className={styles.tablePipelineDetailsMainHeaderRow}>
                                        <p>Candidate Details</p>
                                    </Col>
                                    <Col sm={2} className={styles.tableStstusDetailsMainHeaderRow}>
                                        <p>Status</p>
                                    </Col>
                                    <Col sm={2}>
                                        <Row className={styles.tableInfoDetailsMainHeaderRow}>
                                            <p>Submitted Date and Time</p>
                                        </Row>
                                    </Col>
                                    <Col sm={2}>
                                        <Row className={styles.tableInfoDetailsMainHeaderRow}>
                                            <p>Passing Threshold</p>
                                        </Row>
                                    </Col>
                                    <Col sm={2}>
                                        <Row className={styles.tableShareLinksHeaderRow}>
                                            <p>Review</p>
                                        </Row>
                                    </Col>
                                </div>
                                {filteredValues?.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage).map((candidate, i) => {
                                    return (
                                        <div className={i % 2 === 0 ? styles.tableRowMainDiv : styles.tableRowSecondMainDiv}>
                                            <Col sm={4}>
                                                <Row className={styles.tableJobDetailsMainRow}>
                                                    <Col sm={2}>
                                                        <Avatar name={candidate.candidate_name} size="32" round={true} />
                                                    </Col>
                                                    <Col sm={10}>
                                                        <Row className={styles.tableJobDetailsRow}>
                                                            <p className={styles.tableJobDetails}>{candidate?.candidate_name}</p>
                                                        </Row>
                                                        <Row className={styles.tableJobDetailsRow}>
                                                            <p className={styles.tableSecondJobDetails}>{candidate?.candidate_email}</p>
                                                        </Row>
                                                    </Col>

                                                </Row>

                                            </Col>
                                            <Col sm={2} className='d-flex align-items-center justify-content-center'>
                                                <CustomStatusLabel type={candidate.state === 5 ? 'successStatus' : candidate.state === 0 ? 'warningStatus' : 'dangerStatus'} label={candidate.state === 5 ? 'Submitted for marking' : candidate.state === 0 ? 'Pending' : candidate.state === -40 ? 'Expired' : null}></CustomStatusLabel>
                                            </Col>
                                            <Col sm={2}>
                                                <Row className={styles.tableInfoDetailsMainRow}>
                                                    <Row className={styles.tableInfoDetailsRow}>
                                                        <p className={styles.tableCandidatesInfoDetails}>{candidate?.candidate_submit_date ? moment(candidate?.candidate_submit_date).format('DD MMM YYYY, HH:mmA') : " - "}</p>
                                                    </Row>
                                                </Row>

                                            </Col>
                                            <Col sm={1}>
                                                <Row className={styles.tableCandidatesInfoDetailsRow}>
                                                    <p className={styles.tableCandidatesInfoDetails}>{candidate.pass_score}%</p>
                                                </Row>
                                            </Col>
                                            <Col sm={3}>
                                                <Row className={styles.tableCandidatesInfoDetailsButtonRow}>
                                                    <CustomButton
                                                        buttonType="button"
                                                        label="Review Candidate"
                                                        type="secondaryBtn"
                                                        backicon={
                                                            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                <path d="M9 16.5C13.1421 16.5 16.5 13.1421 16.5 9C16.5 4.85786 13.1421 1.5 9 1.5C4.85786 1.5 1.5 4.85786 1.5 9C1.5 13.1421 4.85786 16.5 9 16.5Z" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                                <path d="M9 12L12 9L9 6" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                                <path d="M6 9H12" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                            </svg>
                                                        }
                                                        handleClick={() => { setSideBar(true); ViewReview(candidate) }}
                                                    />
                                                </Row>
                                            </Col>
                                        </div>
                                    );

                                })
                                }

                            </div>
                            {filteredValues.length > 9 && getUsersIsLoading === false &&

                                <div className={styles.bottomTableDiv}>
                                    <div className={styles.bottomTableControlsWrapper}>
                                        <div className={styles.bottomTableControlsNextBtn}>
                                            <CustomButton
                                                id="other_reviews_go_to_previous_page_btn"
                                                label="Previous"
                                                handleClick={handlePreviousClick}
                                                disabled={currentPage === 1}
                                                type="defaultSmallBtn"
                                            />
                                        </div>
                                        <div>
                                            <CustomButton
                                                id="other_reviews_go_to_next_page_btn"
                                                label="Next"
                                                type="defaultSmallBtn"
                                                handleClick={handleNextClick}
                                                disabled={currentPage === Math.ceil(filteredValues.length / itemsPerPage)}
                                            />
                                        </div>
                                    </div>
                                    <div>
                                        <span className={styles.paginationInfo}>
                                            Page {currentPage} of {totalPages}
                                        </span>
                                    </div>

                                </div>
                            }

                        </Col>
                    </div>
                </div>
            }
        </div>
    )
}

export default ViewOtherReviews;
